import { SprintImport } from '@/components/features/sprints/SprintImport';

export const SprintsPage = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Sprints</h1>
      <SprintImport />
    </div>
  );
};
